document.addEventListener('DOMContentLoaded', () => {
  const updateFreeGift = () => {
    const freeGiftInput = document.querySelector('.freegiftproduct');
    const addToCartButton = document.querySelector('.product-form__submit');
    const selectedRadio = document.querySelector(
      '.selling-plan-container .selling-plan-option .selling-plan-radio:checked'
    );
    if (!selectedRadio || !addToCartButton) return;

    if (selectedRadio.id.includes('selling-plan')) {
      const freeGiftId = freeGiftInput?.value;
      if (freeGiftId) {
        addToCartButton.setAttribute('data-free-product-id', freeGiftId);
      }
    } else if (selectedRadio.id.includes('one-time')) {
      addToCartButton.removeAttribute('data-free-product-id');
    }
  };

  const getOneTime = () => document.querySelector('[skio-onetime-price]')?.textContent.trim() || '';

  const getSubscription = () => document.querySelector('[skio-subscription-price]')?.textContent.trim() || '';

  const updatePrice = () => {
    const selectedRadio = document.querySelector(
      '.selling-plan-container .selling-plan-option .selling-plan-radio:checked'
    );

    let newPrice = '';
    if (selectedRadio) {
      if (selectedRadio.id.includes('one-time')) {
        newPrice = getOneTime();
      } else if (selectedRadio.id.includes('selling-plan')) {
        newPrice = getSubscription();
      }
    }

    const target = document.querySelector('.product-form__buttons .selected-product-price');
    /* PDP1 hybrid ATC (snippets/buy-buttons.liquid, pdph_atc) renders its own
       exact price + Save % chip; never overwrite it with the rounded "• $39". */
    if (target && target.hasAttribute('data-pdph-atc')) return;
    if (target && newPrice !== '') {
      target.innerHTML = `<span class="price-dot">•</span> ${newPrice}`;
    }
  };

  const priceObserver = new MutationObserver(() => {
    updatePrice();
  });

  const oneTimeEl = document.querySelector('[skio-onetime-price]');
  const subEl = document.querySelector('[skio-subscription-price]');

  if (oneTimeEl) {
    priceObserver.observe(oneTimeEl, { childList: true, subtree: true, characterData: true });
  }
  if (subEl) {
    priceObserver.observe(subEl, { childList: true, subtree: true, characterData: true });
  }

  document.querySelectorAll('.selling-plan-container .selling-plan-option .selling-plan-radio').forEach((r) => {
    r.addEventListener('change', updatePrice);
    r.addEventListener('change', updateFreeGift);
  });

  updatePrice();
  updateFreeGift();
});

/* ---------- PDP 1 subscription frequency dropdown ----------

   Opens the frequency list in snippets/skio-app-block.liquid.

   selling-plan-widget owns the other half and that half works: click a
   `.plan-freq` and it finds the `.selling-plan-option` whose `data-option-id`
   matches the clicked `data-plan-freq` and clicks it, which is what lets one
   visible card stand in for all three. What it never did was OPEN the list —
   it calls stopPropagation() on the click and then toggles nothing, so the
   list stayed behind `tw-hidden` and the frequency line was dead to a mouse.

   CAPTURE PHASE IS LOAD-BEARING. Because the widget stops propagation, a
   normal bubble-phase listener on document never sees this click at all.
   Registering with `true` runs this first. Propagation is deliberately NOT
   stopped here: the widget still needs the same click to switch the plan. */
(function () {
  if (window.__pgFreqDropdown) return;
  window.__pgFreqDropdown = true;

  const ROOT = '.selling-plan-container-main ';

  const lists = () => document.querySelectorAll(ROOT + '.frequencies-options');

  function syncExpanded() {
    document.querySelectorAll(ROOT + '.current-selected-freq').forEach((el) => {
      const opts = el.parentElement && el.parentElement.querySelector('.frequencies-options');
      el.setAttribute('aria-expanded', opts && !opts.classList.contains('tw-hidden') ? 'true' : 'false');
    });
  }

  function closeAll() {
    lists().forEach((el) => el.classList.add('tw-hidden'));
    syncExpanded();
  }

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest ? e.target.closest(ROOT + '.current-selected-freq') : null;
      if (trigger) {
        /* The line sits inside <label for="selling-plan-...">, so an
           unprevented click re-fires that label's radio and pulls focus. */
        e.preventDefault();
        const opts = trigger.parentElement.querySelector('.frequencies-options');
        if (!opts) return;
        const willOpen = opts.classList.contains('tw-hidden');
        lists().forEach((el) => {
          if (el !== opts) el.classList.add('tw-hidden');
        });
        opts.classList.toggle('tw-hidden', !willOpen);
        syncExpanded();
        return;
      }
      /* Anything else, a frequency choice included, puts the list away. */
      closeAll();
    },
    true
  );

  /* Keyboard + screen-reader support (PDP1 hybrid, 2026-10-05).
     The list is a listbox: opening it from the keyboard moves focus to the
     current frequency, arrows move between options, Enter/Space choose
     (a real click, so selling-plan-widget switches the plan as it does for a
     mouse), Escape closes and returns focus to the trigger, Tab closes. */
  function optionsOf(list) {
    /* Hidden options (e.g. 12 weeks on 1 box, snippets/pdp-pack-pricing) are skipped. */
    return Array.prototype.slice.call(list.querySelectorAll('.plan-freq')).filter((li) => !li.hidden);
  }

  function decorate() {
    document.querySelectorAll(ROOT + '.plan-frequencies').forEach((wrap) => {
      const trigger = wrap.querySelector('.current-selected-freq');
      const list = wrap.querySelector('.frequencies-options');
      const ul = list && list.querySelector('ul');
      if (!trigger || !ul) return;
      const current = (trigger.querySelector('.frequency-text') || {}).textContent || '';
      ul.setAttribute('role', 'listbox');
      ul.setAttribute('aria-label', 'Delivery frequency');
      optionsOf(list).forEach((li) => {
        li.setAttribute('role', 'option');
        li.setAttribute('tabindex', '-1');
        li.setAttribute('aria-selected', li.textContent.trim() === current.trim() ? 'true' : 'false');
      });
    });
  }

  function openerOf(list) {
    return list.parentElement && list.parentElement.querySelector('.current-selected-freq');
  }

  function visibleTrigger() {
    const all = document.querySelectorAll(ROOT + '.current-selected-freq');
    for (let i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) return all[i];
    }
    return null;
  }

  document.addEventListener(
    'keydown',
    (e) => {
      const el = document.activeElement;
      const inList = el && el.classList && el.classList.contains('plan-freq');

      if (e.key === 'Escape') {
        const openList = document.querySelector(ROOT + '.frequencies-options:not(.tw-hidden)');
        closeAll();
        if (openList) {
          const t = openerOf(openList);
          if (t) t.focus();
        }
        return;
      }

      if (inList) {
        const list = el.closest('.frequencies-options');
        const opts = optionsOf(list);
        const i = opts.indexOf(el);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
          e.preventDefault();
          let n = i;
          if (e.key === 'ArrowDown') n = Math.min(opts.length - 1, i + 1);
          if (e.key === 'ArrowUp') n = Math.max(0, i - 1);
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = opts.length - 1;
          opts[n].focus();
          return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
          /* The plan switch swaps which card is drawn; put focus on the
             frequency line of the card that is now showing. */
          setTimeout(() => {
            decorate();
            const t = visibleTrigger();
            if (t) t.focus();
          }, 60);
          return;
        }
        if (e.key === 'Tab') {
          closeAll();
        }
        return;
      }

      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'ArrowDown') return;
      if (el && el.classList && el.classList.contains('current-selected-freq')) {
        e.preventDefault();
        const list = el.parentElement.querySelector('.frequencies-options');
        const wasOpen = list && !list.classList.contains('tw-hidden');
        if (!(e.key === 'ArrowDown' && wasOpen)) el.click();
        if (list && !list.classList.contains('tw-hidden')) {
          decorate();
          const opts = optionsOf(list);
          const sel = opts.filter((o) => o.getAttribute('aria-selected') === 'true')[0] || opts[0];
          if (sel) sel.focus();
        }
      }
    },
    true
  );

  decorate();
  syncExpanded();
})();
